export default "__VITE_ASSET__BWH3Q0Hb__"